import Request from '@/api/request';

const api = new Request('lk/');

export interface IdentityDocument {
  code: string;
  title: string;
}

export function getIdentityDocuments(): Promise<IdentityDocument[]> {
  return api
    .get('getIdentityDocuments')
    .then((documents: IdentityDocument[]) => {
      return documents;
    });
}
